module.exports = __webpack_public_path__ + "static/media/lm3.a97c61e0.png";